export const GURULLY_DETAILS_REQUEST = "GURULLY_DETAILS_REQUEST";
export const GURULLY_DETAILS_SUCCESS = "GURULLY_DETAILS_SUCCESS";
export const GURULLY_DETAILS_FAIL = "GURULLY_DETAILS_FAIL";